/**
 * Runs `action` (typically opening a dialog) once a Chakra Menu it was chosen
 * from has given focus back. Chakra's Menu returns focus to its button in a
 * `requestAnimationFrame` it schedules as it closes. A dialog opened in the
 * same click saw that focus leave, and its focus lock moved focus to its last
 * control (the Add menu's Submit; the action bar's "Move to Trash", where
 * Enter would trash), defeating the dialog's initial focus (measured in a
 * real browser; jsdom orders these differently, so a jsdom test cannot see
 * it). Our first frame is queued before the menu's, so the second frame runs
 * after focus came back.
 */
export function afterMenuReturnsFocus(action: () => void): void {
  requestAnimationFrame(() => requestAnimationFrame(action));
}
